export default class Controller{

    getData(context,response){
        var t = context;
        if(response.status == 200){
            if(Object.prototype.hasOwnProperty.call(response.data,"ok")){       
                if(response.data.ok){
                    return JSON.parse(response.data.data);
                }
                else{
                    t.$toast.add({
                        severity:"warn",
                        summary:"AVISO",
                        detail:response.data.error,
                        life: 3000
                    });
                    console.log(response);      
                    return JSON.parse(response.data); 
                }
            }
            else{                    
                t.$toast.add({
                    severity:"warn",
                    summary:"AVISO",
                    detail:"La respuesta no tiene el formato correcto",
                    life: 3000
                });
                console.log(response);    
                return null;                
            }
        }
        else{
            t.$toast.add({
                severity:"error",
                summary:"ERROR",
                detail:"No se pudo procesar la solicitud correctamente",
                life: 3000
            });
            console.log(response);
            return null;
        }
    }

}
